(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esteem-bogo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('esteem-bogo-offer')) {
    customElements.define('esteem-bogo-offer', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.labels = { ...this.dataset };
        this.code = this.dataset.code;
        this.variants = new Set(this.dataset.variants.split(','));
        this.container = this.closest('[data-section-type="product"]');
        this.events = new AbortController();
        this.refresh = this.refresh.bind(this);
        this.apply = this.apply.bind(this);
        this.onVariant = (event) => {
          const variant = event.detail.variant;
          this.hidden = !variant || !variant.available ||
            !(this.dataset.allVariants === 'true' || this.variants.has(String(variant.id)));
        };
        this.button.addEventListener('click', this.apply, { signal: this.events.signal });
        this.container?.addEventListener('theme:variant:change', this.onVariant, { signal: this.events.signal });
        document.addEventListener('theme:cart:change', this.refresh, { signal: this.events.signal });
        window.addEventListener('pageshow', this.refresh, { signal: this.events.signal });
        this.refresh();
      }
      disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
      async cart(path, body) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          ...(body ? { body: JSON.stringify(body) } : {}),
          signal: AbortSignal.timeout(10000)
        });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }
      render(cart) {
        const code = (cart.discount_codes || []).find(entry => entry.code.toUpperCase() === this.code.toUpperCase());
        this.dataset.state = code ? 'selected' : 'idle';
        this.button.textContent = code ? (code.applicable ? this.labels.applied : this.labels.selected) : this.labels.apply;
        this.status.textContent = code ? (code.applicable ? this.labels.success : this.labels.ready) : this.labels.terms;
      }
      async refresh() {
        if (this.busy) return;
        const revision = this.revision || 0;
        try {
          const cart = await this.cart('cart.js');
          if (this.isConnected && !this.busy && revision === (this.revision || 0)) this.render(cart);
        } catch {}
      }
      async apply() {
        if (this.busy) return;
        this.busy = true;
        this.revision = (this.revision || 0) + 1;
        this.button.disabled = true;
        this.button.textContent = this.labels.saving;
        this.setAttribute('aria-busy', 'true');
        const blockPurchase = (event) => {
          if (event.target.closest('[data-add-to-cart], .shopify-payment-button')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        document.addEventListener('click', blockPurchase, true);
        try {
          const current = await this.cart('cart.js');
          const codes = (current.discount_codes || []).map(entry => entry.code);
          if (!codes.some(code => code.toUpperCase() === this.code.toUpperCase())) codes.push(this.code);
          const updated = await this.cart('cart/update.js', { discount: codes.join(',') });
          if (!(updated.discount_codes || []).some(entry => entry.code.toUpperCase() === this.code.toUpperCase())) throw new Error('Code was not saved');
          this.render(updated);
          if (updated.item_count > 0) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } catch {
          this.button.textContent = this.labels.apply;
          this.status.textContent = this.labels.error;
          this.dataset.state = 'idle';
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
          document.removeEventListener('click', blockPurchase, true);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-editorial-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('esteem-editorial-guide')){
customElements.define('esteem-editorial-guide',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;
const body=this.querySelector('.esteem-guide__body');
if(!body)return;
body.querySelectorAll('table').forEach(table=>{const wrap=document.createElement('div');wrap.className='esteem-guide__table';wrap.tabIndex=0;table.before(wrap);wrap.append(table);});
this.dataset.ready='true';
const nodes=Array.from(body.childNodes);
let intro=document.createElement('div');
intro.className='esteem-guide__intro';
body.append(intro);
let destination=intro;
nodes.forEach(node=>{
if(node.nodeType===1&&node.tagName==='H2'){
const chapter=document.createElement('section');
chapter.className='esteem-guide__chapter';
const content=document.createElement('div');
content.className='esteem-guide__chapter-content';
chapter.append(node,content);
body.append(chapter);
destination=content;
const title=node.textContent.trim();
if(title==='Best Esteem Apparel Options by Goal'||title==='Best Esteem Apparel Options by Need'||title==='Compression Undershirt vs Tank vs Binder')chapter.classList.add('esteem-guide__chapter--cards');
if(title==='Final Thoughts'||title==='The bottom line')chapter.classList.add('esteem-guide__chapter--final');
}else destination.append(node);
});
body.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
body.querySelectorAll('.esteem-guide__chapter').forEach(chapter=>{
const title=chapter.querySelector('h2').textContent.trim();
if(chapter.classList.contains('esteem-guide__chapter--cards'))chapter.querySelectorAll('ul').forEach(ul=>ul.classList.add('guide-cards'));
if(title==='Key Benefits of Gynecomastia Compression Shirts'||title==='Spanx for Men vs Esteem Apparel')chapter.querySelectorAll('ul').forEach(ul=>ul.classList.add('guide-benefits'));
if(title==='What Actually Matters When Choosing a Compression Shirt'||title==='What Actually Matters Before You Buy')chapter.querySelectorAll('p').forEach(p=>{if(p.querySelector('strong'))p.classList.add('guide-factor');});
});
body.querySelectorAll('div[style]').forEach(div=>{if(div.querySelector('a[style]')){div.classList.add('guide-cta');div.querySelectorAll(':scope > br').forEach(br=>br.remove());}});
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-pack-value"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('esteem-pack-value'))customElements.define('esteem-pack-value',class extends HTMLElement{
connectedCallback(){
this.events=new AbortController();
this.closest('[data-section-type="product"]')?.addEventListener('theme:variant:change',event=>{
const id=String(event.detail.variant?.id||'');let found=false;
this.querySelectorAll('[data-pack-id]').forEach(panel=>{panel.hidden=panel.dataset.packId!==id;if(!panel.hidden)found=true;});this.hidden=!found;
},{signal:this.events.signal});
if(!this.querySelector('[data-pack-id]:not([hidden])'))this.hidden=true;
}
disconnectedCallback(){this.events?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('esteem-product-details')) {
    customElements.define('esteem-product-details', class extends HTMLElement {
      connectedCallback() {
        if (!this.enhanced) {
          this.enhanced = true;
          const nodes = Array.from(this.childNodes);
          const headings = nodes.filter(node => node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName));
          if (headings.length) {
            const output = document.createDocumentFragment();
            const intro = document.createElement('div');
            intro.className = 'esteem-details__intro';
            output.append(intro);
            let body = intro;
            nodes.forEach(node => {
              if (headings.includes(node)) {
                const details = document.createElement('details');
                details.className = 'esteem-details__section';
                const summary = document.createElement('summary');
                summary.append(node);
                body = document.createElement('div');
                body.className = 'esteem-details__body';
                details.append(summary, body);
                output.append(details);
              } else {
                body.append(node);
              }
            });
            if (!intro.textContent.trim() && !intro.querySelector('img,video,iframe')) intro.remove();
            this.append(output);
          }
        }
        this.events = new AbortController();
        this.revealAnchor = () => {
          let id;
          try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
          if (!id) return;
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          for (let parent = target; parent && parent !== this; parent = parent.parentElement) {
            if (parent.tagName === 'DETAILS') parent.open = true;
          }
        };
        window.addEventListener('hashchange', this.revealAnchor, { signal: this.events.signal });
        this.addEventListener('toggle', () => {
          this.dispatchEvent(new CustomEvent('theme:form:sticky', { bubbles: true, detail: { element: 'accordion' } }));
        }, { capture: true, signal: this.events.signal });
        this.revealAnchor();
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-size-calculator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('esteem-size-calculator'))customElements.define('esteem-size-calculator',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const dialog=this.querySelector('dialog'),strings=this.querySelector('[data-esc-strings]').dataset;
  const tabs=[...this.querySelectorAll('[data-esc-tab]')];
  const variants=JSON.parse(this.querySelector('[data-esc-variants]').textContent);
  const optionIndex=JSON.parse(this.querySelector('[data-esc-options]').textContent).findIndex(x=>/^size$/i.test(x));
  const normalize=x=>({MEDIUM:'M',MED:'M',LARGE:'L',LG:'L',XLARGE:'XL',XXLARGE:'2XL',XXL:'2XL',XXXLARGE:'3XL',XXXL:'3XL','3XL':'3XL',SMALL:'S'}[String(x).toUpperCase().replace(/[^A-Z0-9]/g,'')]||String(x).toUpperCase());
  const chart=this.querySelector('.esc-chart'),table=chart.querySelector('table');
  const headers=table?[...table.querySelectorAll('thead th')].map(x=>x.textContent.toLowerCase()):[];
  const chestCol=headers.findIndex(x=>x.includes('chest')),waistCol=headers.findIndex(x=>x.includes('waist'));
  const rows=table&&chestCol>=0&&waistCol>=0?[...table.querySelectorAll('tbody tr')].map(tr=>{const cells=[...tr.children];const range=i=>(cells[i].textContent.match(/\d+(?:\.\d+)?/g)||[]).map(Number);return {size:normalize(cells[0].textContent),chest:range(chestCol),waist:range(waistCol),cells};}).filter(r=>r.chest.length===2&&r.waist.length===2):[];
  let unit='in',values={chest:null,waist:null},priorOverflow='';
  const fields=[...this.querySelectorAll('[data-measure]')];
  const result=(label,size='',note='')=>{this.querySelector('[data-esc-result-label]').textContent=label;this.querySelector('[data-esc-result-size]').textContent=size;this.querySelector('[data-esc-result-note]').textContent=note;};
  const recommend=()=>{
   if(!rows.length)return result(strings.unsupported);
   if(Object.values(values).some(x=>x===null))return result(strings.empty);
   if(Object.values(values).some(x=>!Number.isFinite(x)||x<=0))return result(strings.invalid);
   const indices=['chest','waist'].map(k=>values[k]<rows[0][k][0]-0.00001?-1:rows.findIndex(r=>values[k]<=r[k][1]+0.00001));
   if(indices.includes(-1))return result(strings.outside);
   const size=rows[Math.max(...indices)].size;
   const offered=variants.filter(v=>normalize(v.options[optionIndex])===size);
   if(!offered.length)return result(strings.unmapped);
   result(strings.recommend,size,strings.resultNote+(offered.some(v=>v.available)?'':' '+strings.unavailable));
  };
  const sync=()=>{
   const factor=unit==='cm'?2.54:1;
   fields.forEach(f=>{const k=f.dataset.measure,n=f.querySelector('[data-esc-number]'),slider=f.querySelector('[data-esc-range]');n.value=values[k]===null?'':Math.round(values[k]*factor*100)/100;slider.min=20*factor;slider.max=60*factor;slider.step='0.01';slider.value=(values[k]||36)*factor;slider.setAttribute('aria-valuetext',values[k]===null?'':n.value+' '+unit);f.querySelector('[data-esc-suffix]').textContent=unit;f.querySelector('[data-esc-min]').textContent=Math.round(20*factor*10)/10+' '+unit;f.querySelector('[data-esc-max]').textContent=Math.round(60*factor*10)/10+' '+unit;});
   rows.forEach(r=>['chest','waist'].forEach(k=>{r.cells[k==='chest'?chestCol:waistCol].textContent=r[k].map(n=>Math.round(n*factor*100)/100).join('–');}));
   if(rows.length){table.querySelectorAll('thead th')[chestCol].textContent=headers[chestCol].replace(/\(.*\)/,'')+' ('+unit+')';table.querySelectorAll('thead th')[waistCol].textContent=headers[waistCol].replace(/\(.*\)/,'')+' ('+unit+')';}
  };
  fields.forEach(f=>{const n=f.querySelector('[data-esc-number]'),slider=f.querySelector('[data-esc-range]');[n,slider].forEach(input=>input.addEventListener('input',()=>{values[f.dataset.measure]=input.value===''?null:Number(input.value)/(unit==='cm'?2.54:1);if(input===slider)n.value=input.value;else if(input.value!=='')slider.value=input.value;slider.setAttribute('aria-valuetext',input.value+' '+unit);recommend();}));});
  this.querySelectorAll('[data-esc-unit]').forEach(b=>b.addEventListener('click',()=>{unit=b.dataset.escUnit;this.querySelectorAll('[data-esc-unit]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));sync();recommend();}));
  const activate=b=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===b));t.tabIndex=t===b?0:-1;});this.querySelectorAll('[data-esc-panel]').forEach(p=>p.hidden=p.dataset.escPanel!==b.dataset.escTab);};
  tabs.forEach((b,i)=>{b.addEventListener('click',()=>activate(b));b.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const t=tabs[e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+1)%tabs.length];activate(t);t.focus();}});});
  const opener=this.querySelector('[data-esc-open]');
  opener.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();priorOverflow=document.documentElement.style.overflow;dialog.showModal();dialog.scrollTop=0;document.documentElement.style.overflow='hidden';this.querySelector('[data-esc-close]').focus();});
  this.querySelector('[data-esc-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=priorOverflow;opener.focus();});
  sync();recommend();
 }
});
  } catch(e) { console.error(e); }
})();

})();
